import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'

const infoSwitch = (currentScreen) => {
  switch (currentScreen) {
    case 'validation':
      return (
        <>
          <li>Si no le llega el código, revise si tienes buena señal.</li>
          <li>El código cambia cada vez que inicia sesión a su cuenta.</li>
          <li>Cualquier duda comuníquese con transito.</li>
        </>
      )
    case 'main':
      return (
        <>
          <li>Siempre prestar atención a las alertas.</li>
          <li>
            Para realizar la entrega del producto, seleccione{' '}
            <span className="dark:text-white-darkMode font-medium text-gray-700">
              &quot;Continuar&quot;.
            </span>
          </li>
          <li>Para llamar al cliente, haga click en el icono del teléfono.</li>
          <li>
            Si quieren abrir Waze con la dirección de destino, haga click en el
            icono de Waze.
          </li>
          <li>
            Si quiere ir a la dirección siguiente, postergando la orden, pulse
            el botón con el icono en forma de reloj que se encuentra a
            continuación del botón &quot;Continuar&quot;.
          </li>
          <li>
            Si quiere ver la lista de los pedidos a entregar y su estado de
            entrega, pulse el botón con icono de camion que se encuentra en la
            navegación inferior.
          </li>
          <li>
            Si quiere la lista completa de los productos a entregar en el pedido
            actual, despliegue la lista de productos.
          </li>
        </>
      )
    case 'deliverOrder':
      return (
        <>
          <li>Siempre prestar atención a las alertas.</li>
          <li>
            Seleccione si entrego o no el producto para poder finalizar la
            entrega.
          </li>
          <li>Si no lo entregó, suba la foto del domicilio del cliente.</li>
          <li>
            En la observación coloque quien recibió el producto si es que no fue
            el titular.
          </li>
          <p className="dark:text-white-darkMode/80 pt-4 pb-2 text-xs text-gray-700">
            Si el cliente cuenta con las siguientes características deberá
            validar la identidad con su DNI físico y la tarjeta de crédito
            físico, estos son:
          </p>
          <li>Cliente no aprobó la validación.</li>
          <li>Cliente se niega a presentar la documentación.</li>
          <li>El titular de la compra no estaba presente.</li>
        </>
      )
    case 'ordersList':
      return (
        <>
          <li>
            Pulse en las diferentes pestañas para ver el listado de las ordenes
            según sus estados.
          </li>
          <li>
            En las pestañas &quot;Pospuestas &quot; y &quot;No entregadas &quot;
            para volver a entregar la orden, pulse el botón con icono con forma
            de flecha.
          </li>
        </>
      )
    default:
      return (
        <>
          <li>Cualquier duda comuníquese con transito.</li>
        </>
      )
  }
}

const HelpModal = ({ closeModal, isOpen }) => {
  const { currentScreen } = useDeliveryAppContext()
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-black/50 dark:bg-gray-darkMode/75 fixed inset-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="rounded-2xl dark:bg-black-darkMode flex flex-col items-center justify-between w-full h-auto max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white-darkMode w-full pb-3 mb-3 text-lg font-medium leading-6 text-center text-gray-700 border-b"
                  >
                    Ayuda
                  </Dialog.Title>

                  <ul className="dark:text-gray-400 flex flex-col gap-1 pl-3 text-xs text-left text-gray-500 list-disc">
                    {infoSwitch(currentScreen)}
                  </ul>

                  <div className="flex flex-col w-full">
                    <button
                      type="button"
                      className="bg-orange-primary dark:bg-orange-darkMode hover:opacity-80 inline-flex justify-center px-4 py-2 mt-6 text-sm font-medium text-white rounded-md"
                      onClick={closeModal}
                    >
                      Entendido
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default HelpModal
